var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "contents" },
    [
      _c("editor", {
        key: _vm.refreshKey,
        ref: "editor",
        staticClass: "tiny-editor",
        attrs: {
          "api-key": "4wu8sj881tkfcg0i74t9scvjecuik9of64nw6tazu5iu8uqe",
          init: _vm.config,
        },
        on: { onChange: this.update },
        model: {
          value: _vm.content,
          callback: function ($$v) {
            _vm.content = $$v
          },
          expression: "content",
        },
      }),
      _vm._v(" "),
      _c("small", { staticClass: "error--text px-3" }, [
        _vm._v(_vm._s(_vm.errors)),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }